/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type shifts_UpdateShiftRequest = {
    /**
     * Optional break end time in HH:MM 24-hour format (e.g., "13:00"). Local to the organization's timezone.
     */
    break_end?: string;
    /**
     * Break duration in minutes (subtracted from gross hours to calculate net hours)
     */
    break_minutes?: number;
    /**
     * Optional break start time in HH:MM 24-hour format (e.g., "12:00"). Local to the organization's timezone.
     */
    break_start?: string;
    /**
     * Timestamp of when the shift was last updated, used for optimistic locking (RFC3339 format)
     */
    current_updated_at: string;
    /**
     * ID of the employee this shift is assigned to. Empty for an open shift (open_shift = true).
     */
    employee_id?: string;
    /**
     * End time in HH:MM 24-hour format (e.g., "16:00"). Local to the organization's timezone. Exclusive boundary for conflict detection.
     */
    end_time: string;
    /**
     * Optional list of group IDs to assign this shift to
     */
    group_ids?: Array<string>;
    /**
     * Optional notes about the shift
     */
    notes?: string;
    /**
     * True keeps or makes the shift OPEN, without an employee (#2040). An open shift needs at least
     * one group and cannot be CONFIRMED.
     */
    open_shift?: boolean;
    /**
     * Date of the shift in ISO 8601 format (YYYY-MM-DD), local to the organization's timezone
     */
    shift_date: string;
    /**
     * Type of shift: REGULAR (standard work), OVERTIME (extra hours), ON_CALL (availability)
     */
    shift_type: shifts_UpdateShiftRequest.shift_type;
    /**
     * Start time in HH:MM 24-hour format (e.g., "08:00"). Local to the organization's timezone.
     */
    start_time: string;
    /**
     * Status of the shift: DRAFT (editable), PUBLISHED (visible), CONFIRMED (accepted), CANCELLED
     */
    status: shifts_UpdateShiftRequest.status;
};
export namespace shifts_UpdateShiftRequest {
    /**
     * Type of shift: REGULAR (standard work), OVERTIME (extra hours), ON_CALL (availability)
     */
    export enum shift_type {
        REGULAR = 'REGULAR',
        OVERTIME = 'OVERTIME',
        ON_CALL = 'ON_CALL',
    }
    /**
     * Status of the shift: DRAFT (editable), PUBLISHED (visible), CONFIRMED (accepted), CANCELLED
     */
    export enum status {
        DRAFT = 'DRAFT',
        PUBLISHED = 'PUBLISHED',
        CONFIRMED = 'CONFIRMED',
        CANCELLED = 'CANCELLED',
    }
}

